import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Row } from '../grid/experimental.grid';

export interface FocusSelectorSelectActiveForPerformerRow {
    rowId: Row['id'];
}

export const focusSelectorSelectActiveForPerformerRow = createAction<
    ActionType,
    FocusSelectorSelectActiveForPerformerRow
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_ACTIVE_FOR_PERFORMER_ROW);
